import React from 'react'
import { PromotionForm } from './PromotionForm'
import { useClients } from '../../../hooks'

export const CreatePromotion = () => {
  const { data: clients } = useClients()

  return <PromotionForm method="post" clients={clients} />
}
